/*eslint-disable*/
import axios from "axios";
import apiConfig from './api.config';
class MenuService {
    getAllDescubre() {
        return axios.get(`/descubre-collections?populate[submenu][populate]=*`, apiConfig.connData());
    }
    getDescubre(id) {
        return axios.get(`/descubre-collections/${id}?populate[submenu][populate]=*`, apiConfig.connData());
    }
    getAllDisfruta() {
        return axios.get(`/disfruta-collections?populate[submenu][populate]=*`, apiConfig.connData());
    }
    getDisfruta(id) {
        return axios.get(`/disfruta-collections/${id}?populate[submenu][populate]=*`, apiConfig.connData());
    }
}
export default new MenuService();